/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';

const LinkWithMiniBrowser = ({
  children,
  className,
  disabled = false,
  height,
  target,
  url = '#',
  width
}) => {
  if (disabled) {
    className = className + ' tw-pointer-events-none';
  }
  return (
    <a
      className={className}
      style={{ opacity: disabled ? '0.65' : '1' }}
      href={url}
      onClick={() => {
        if (disabled || url === '#') {
          return false;
        }

        const screenW = window.screen.width;
        const screenH = window.screen.height;

        const w =
          width === 'full'
            ? (window.innerWidth
                ? window.innerWidth
                : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : window.screen.width) * 0.8
            : width;
        const h =
          height === 'full'
            ? (window.innerHeight
                ? window.innerHeight
                : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : window.screen.height) * 0.8
            : height;
        const systemZoom = screenW / window.screen.availWidth;
        const left = (screenW - w) / 2 / systemZoom + window.screenX;
        const top = (screenH - h) / 2 / systemZoom + window.screenY;

        window.open(
          url,
          'PayPalFrame',
          `resizable,scrollbars,top=${top},left=${left},width=${w},height=${h}`
        );
        return false;
      }}
      target={target}
    >
      {children}
    </a>
  );
};

export default LinkWithMiniBrowser;
export { LinkWithMiniBrowser };
